import { render, staticRenderFns } from "./InProductPreDescrip.vue?vue&type=template&id=79ffbdda&scoped=true&"
import script from "./InProductPreDescrip.vue?vue&type=script&lang=js&"
export * from "./InProductPreDescrip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ffbdda",
  null
  
)

export default component.exports